/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import moment from 'moment';
import { GenerateDateandTime, GenerateDate } from '../../../../redux/helper/DateConverter';

function OrderInfoToolTip({ OrderDetails }) {
    return (
        <div id="tooltip-discountPrice" role="tooltip" className="inline-block absolute z-10 sm:pl-5 sm:pr-4 px-2 pb-2 sm:pt-4 pt-2.5 bg-white rounded-lg shadow-s2 sm:min-w-[284px] w-[250px]">
            <p className="text-sm45 font-semibold text-[#808285]">Request Date</p>
            <p className="text-sm46 font-semibold text-[ #090406] pt-[8px]">{GenerateDateandTime(Number(OrderDetails.request_date) / 1000)}</p>
            <div className="flex justify-between pt-[18px]">
                <div className=" ">
                    <p className="text-sm45 font-semibold text-[#808285]">PO Number</p>
                    <p className="text-sm46 pt-[8px] font-semibold text-[ #090406]">{OrderDetails.po_number}</p>
                </div>
                <div className="pr-[25px] text-start">
                    <p className="text-sm45  font-semibold text-[#808285]">PO Date </p>
                    <p className="text-sm46 pt-[8px] font-semibold text-[ #090406]">{GenerateDateandTime(Number(OrderDetails.po_date) / 1000)}</p>
                </div>
            </div>
            <div className="flex justify-between pt-[18px]">
                <div className="">
                    <p className="text-sm45 font-semibold text-[#808285]">Freight Terms</p>
                    <p className="text-sm46 pt-[8px] font-semibold text-[ #090406]">{OrderDetails.freight_terms}</p>
                </div>
                <div className="">
                    <p className="text-sm45 font-semibold text-[#808285]">Delivery Terms</p>
                    <p className="text-sm46  pt-[8px] font-semibold text-[ #090406]">{OrderDetails.delivery_terms}</p>
                </div>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </div>
    );
}

export default OrderInfoToolTip;
